import { finish, error } from '../../../modules/market-templates/actions/move-selections';


export function request(dispatch, { sportId, eventTemplateId, marketTemplateId, data }) {

    $appState.sdkStaff.patchMarketTemplateSelectionsReorder({
        requestBody: {
            marketTemplateId,
            eventTemplateId,
            sportId,
            data
        }
    }).then(
        data => dispatch(finish(data)),
        errors => dispatch(error(errors))
    );
}
